import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

import Button from 'components/button';
import MapOfNigeria from 'components/mapOfNigeria';
import Feature from 'components/feature';

import MarketChartsFilters from './MarketChartsFilters';
import MarketChartsProductSummary from './MarketChartsProductSummary';
import MarketChartsDate from './MarketChartsDate';

import {
  chartHeader,
  chartBody,
  buttonsContainer,
} from './scss/MarketCharts.module.scss';

const MarketIndex = ({ theme }) => {
  const [activeProduct, setActiveProduct] = useState({});
  return (
    <Row noGutters>
      <Col lg="4" xl="3">
        <MarketChartsFilters
          selectedProduct={activeProduct}
          onProductSelect={setActiveProduct}
        />
      </Col>
      <Col>
        <section>
          <div className={chartHeader}>
            <MarketChartsProductSummary product={activeProduct} />
            <Feature>
              <MarketChartsDate />
            </Feature>
          </div>
          <div className={chartBody}>
            <MapOfNigeria activeProduct={activeProduct} theme={theme} />
            <Feature>
              <div className={buttonsContainer}>
                <Button tag={Link} buttonColor="red" to="/register">
                  Open Trading Account
                </Button>
                <Button tag={Link} buttonColor="gray" to="/register">
                  Try Demo
                </Button>
              </div>
            </Feature>
          </div>
        </section>
      </Col>
    </Row>
  );
};

MarketIndex.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']),
};

MarketIndex.defaultProps = {
  theme: 'dark',
};

export default MarketIndex;
